import serializeFormData from "@utils/serialize-form-data"
import appendUtmParams from "./appendUtmParams"
import { getSignupAppData } from "./signupAppRedirects"

export const formatNorthstar = (values) => {
  const utmParams = appendUtmParams()
  const inAppParams = getSignupAppData(values)
  const data = {
    ...utmParams,
    ...inAppParams,
    name: values.Company,
    phone_number: values.Phone,
    first_name: values.FirstName,
    last_name: values.LastName,
    email: values.Email,
    country: values.Country,
    state: values.State,
    website: values.Website,
    role: values.Role,
    plans: values.plans,
    "owner[login]": values.Email,
    "owner[name]": `${values.FirstName} ${values.LastName}`,
    "owner[password]": values.Password,
    marketing_opt_in: values.Opt_In_GDPR__c,
    "g-recaptcha-response": values.recaptcha,
  }
  return serializeFormData(data)
}

export const submitNorthstar = async (values) => {
  const FASTLY_SIGNUP_URL = process.env.GATSBY_FASTLY_SIGNUP_URL || "https://www.fastly.com/signup/and_confirm"
  const res = await fetch(FASTLY_SIGNUP_URL, {
    method: "POST",
    body: values,
    headers: {
      "Fastly-Ui-Client": "www-fastly-com",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  })

  // northstar returns 400 if there are validation errors
  // the response body will be a JSON object with an errors property
  if (!res.ok) {
    // Handle both potential VPN cases
    if (res.status === 503 || res.status === 403) {
      return Promise.reject(
        new Error(`Northstar VPN error: ${res.status}`, {
          cause: { code: "NorthstarVpnError", status: res.status },
        })
      )
    } else if (res.status === 406) {
      return Promise.reject(
        new Error(`SigSci error: ${res.status}`, {
          cause: { code: "SigSciError", status: res.status },
        })
      )
    } else if (res.status !== 400) {
      return Promise.reject(
        new Error(`Northstar network error: ${res.status}`, {
          cause: { code: "NorthstarNetworkError", status: res.status },
        })
      )
    }
  }

  const json = await res.json()

  if (res.ok) {
    // Track conversion
    // ITRK-2171: Temporarily disabling while investigating error with signup
    // window.LUX?.addData("signup", true)

    return json
  }

  // validation errors
  let errors = {}
  if (json.errors) {
    if (json.errors.password) {
      // setError for password
      errors.Password = json.errors.password
    }
    if (json.errors.email) {
      // setError for email
      errors.Email = json.errors.email
    }
    if (json.errors.recaptcha) {
      // setError for recaptcha
      errors.recaptcha = json.errors.recaptcha
    }
    if (json.errors.company) {
      // setError for company
      errors.Company = json.errors.company
    }

    return Promise.reject(new Error("Validation Errors", { cause: { code: "ValidationErrors", errors: errors } }))
  }

  if (json.msg) {
    return Promise.reject(new Error(json.msg, { cause: { code: "SignupsDisabled", status: res.status } }))
  }

  return Promise.reject(
    new Error(`Northstar network error: ${res.status}`, {
      cause: { code: "NorthstarNetworkError", status: res.status },
    })
  )
}
